import React, { useState } from 'react'
import { formatPrice } from '../../../../shared/js/formatters'

export default function GoldBuyingSimulator({ cents }: { cents: number }) {
  const [weight, setWeight] = useState(0)

  return (
    <>
      <p className='field'>
        <input
          type='number'
          name='weight'
          onChange={handleChange}
          value={weight}
        />
        <label htmlFor='number'>Poids (en grammes)</label>
      </p>
      <p>
        {weight > 0
          ? `estimé à ${formatPrice(cents * weight)}`
          : `Cours actuel : ${formatPrice(cents)} / g`}
      </p>
    </>
  )

  function handleChange({ target: { value } }) {
    setWeight(Number(value))
  }
}
